import React from "react";
import PartyOrganisation from "../../manage-party/PartyOrganisation";
import {
  PartyFormContextValue,
  PartyFormMode,
  PartyFormProvider,
} from "../../manage-party/PartyFormContext";

const organisationContext: PartyFormContextValue = {
  mode: PartyFormMode.Admin,
  partyType: "Organisation",
  allowPartySearch: true,
  allowMerge: false,
  allowDelete: false,
  allowPartyTypeChange: false,
  allowServiceSelection: false,
  allowViewInternalIds: false,
  allowNavigation: false,
};

interface OrganisationOption {
  tenantId: number;
  name: string;
}

interface OrganisationDetailsStepProps {
  tenantId: number;
  partyId: number;
  organisations?: OrganisationOption[];
  onOrganisationSelect?: (tenantId: number) => void;
  onSaved: () => void;
}

export default function OrganisationDetailsStep({
  tenantId,
  partyId,
  organisations,
  onOrganisationSelect,
  onSaved,
}: OrganisationDetailsStepProps) {
  return (
    <section className="tenant-admin-details">
      <PartyFormProvider value={organisationContext}>
        <PartyOrganisation
          key={tenantId}
          partyId={partyId}
          resetSignal={0}
          saveLabel="Save organisation"
          organisationEndpoint={`/api/tenant-administration/${tenantId}/organisation`}
          showServiceEnrollment={false}
          showOrganisationMembers={false}
          organisationOptions={organisations?.map((organisation) => ({
            value: organisation.tenantId,
            label: organisation.name,
          }))}
          selectedOrganisationId={tenantId}
          onOrganisationSelect={onOrganisationSelect}
          onSaved={onSaved}
        />
      </PartyFormProvider>
    </section>
  );
}
